import { useState } from 'react';
import '../../../utils/index.js';
import { filterContentByPermissions } from '../../../utils/filterContent.js';

/**
 *
 * useSectionFilter
 *
 * Filters the section content items.
 * This component filters by:
 *  - Section category (section filter),
 *  - User permissions (editor / viewer / admin - designer / non-designer)
 *
 * It also splits the content by featured and non featured items, where featured
 * are the first items in the array.
 *
 */
const useSectionFilter = ({ selectedFilter, userPermissions, items, }) => {
    const [sectionFilter, setSectionFilter] = useState(selectedFilter);
    const filteredItems = filterContentByPermissions({
        userPermissions,
        contents: items || [],
    });
    const initialState = { featured: [], nonFeatured: [] };
    // Filter Items by Category and split items by featured vs non-featured
    const filterFeatured = filteredItems.reduce((acc, curr) => {
        var _a, _b;
        if (sectionFilter &&
            !((_b = (_a = curr.permissions) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.includes(sectionFilter))) {
            // Apply section filter and skip items
            return acc;
        }
        // Split featured items
        if (curr.featured) {
            acc.featured.push(curr);
        }
        else {
            acc.nonFeatured.push(curr);
        }
        return acc;
    }, initialState);
    return { items: filterFeatured, sectionFilter, setSectionFilter };
};

export { useSectionFilter };
